import React from 'react';
import Header from '../Header';
import Searchbox from '../SearchBox';
import Headline from '../HeadLine';
import HeroImage from '../HeroImage';
import Jumbotron from '../Jumbotron';

const HeroContent = () => (
  <header role="banner">
    <HeroImage>
      <Header />
      <Jumbotron>
        <Headline />
        <Searchbox />
      </Jumbotron>
    </HeroImage>
  </header>
);

export default HeroContent;



// WEBPACK FOOTER //
// ./src/universal/components/HeroContent/HeroContent.js